// components/blog/CategorySelector.js
import React from 'react';
import { useFormContext } from 'react-hook-form';

const CategorySelector = ({ categories }) => {
  const { watch, setValue } = useFormContext();
  const selectedIds = watch('category_ids') || [];

  const handleToggle = (id) => {
    const updated = selectedIds.includes(id)
      ? selectedIds.filter((val) => val !== id)
      : [...selectedIds, id];
    setValue('category_ids', updated);
  };

  // Ordenar: primero padres, luego hijos
  const sorted = [...categories].sort((a, b) => {
    if (!a.parent_id && b.parent_id) return -1;
    if (a.parent_id && !b.parent_id) return 1;
    return a.name.localeCompare(b.name);
  });

  return (
    <div className="space-y-1 max-h-48 overflow-y-auto pr-1">
      {sorted.map((cat) => (
        <label key={cat.id} className="flex items-center text-sm text-gray-700">
          <input
            type="checkbox"
            checked={selectedIds.includes(cat.id)}
            onChange={() => handleToggle(cat.id)}
            className="mr-2"
          />
          {cat.parent_id ? '↳ ' : ''}{cat.name}
        </label>
      ))}
    </div>
  );
};

export default CategorySelector;
